import {
    DashboardOutlined,
    UserAddOutlined,
    UserOutlined,
    CarOutlined,
    GroupOutlined,
    BarsOutlined,
    ProfileOutlined,
    HomeOutlined,
    ShopOutlined,
    FileImageOutlined,
    ShoppingCartOutlined,
    SettingOutlined,
    MessageOutlined,
    IssuesCloseOutlined,
    GiftOutlined,
    LineChartOutlined,
    CompassOutlined,
    CheckOutlined
} from '@ant-design/icons';
import store from '../redux/store';
import service from 'auth/FetchInterceptor';
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH, ADMIN_API_BASE_ENDPOINT } from 'configs/AppConfig'
const state = store.getState();
const userAccessData = state.auth.userData !== null && state.auth.userData.role_id.length > 0 && state.auth.userData.role_id !== undefined ? state.auth.userData.role_id[0].role_access : [];
const dashBoardNavTree = [
    {
        key: 'main-sidebar',
        path: `${APP_PREFIX_PATH}/home`,
        title: 'Dashboards',
        icon: DashboardOutlined,
        breadcrumb: false,
        submenu: [
            {
                key: 'home',
                path: `${APP_PREFIX_PATH}/home`,
                title: 'Dashboard',
                icon: DashboardOutlined,
                breadcrumb: false,
                show: userAccessData.includes('home') ? true : false,
                submenu: []
            },
            {
                key: 'approve_list',
                path: `${APP_PREFIX_PATH}/approve/lists`,
                title: 'Approve List',
                icon:  CheckOutlined,
                breadcrumb: false,
                show: userAccessData.includes('approve_list') ? true : false,
                submenu: []
            },
            {
                key: 'users',
                path: `${APP_PREFIX_PATH}/users/admins`,
                title: 'Users',
                icon: UserAddOutlined,
                breadcrumb: false,
                show: userAccessData.includes('users') || userAccessData.includes('users-role') || userAccessData.includes('users-admins') ? true : false,
                submenu: [
                    {
                        key: 'users-role',
                        path: `${APP_PREFIX_PATH}/users/role/list`,
                        title: 'Roles',
                        icon: SettingOutlined,
                        breadcrumb: false,
                        show: userAccessData.includes('users') || userAccessData.includes('users-role') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'users-admins',
                        path: `${APP_PREFIX_PATH}/users/admins/list`,
                        title: 'Admin',
                        icon: UserAddOutlined,
                        breadcrumb: false,
                        show: userAccessData.includes('users') || userAccessData.includes('users-admins') ? true : false,
                        submenu: []
                    }
                ]
            },
            {
                key: 'customer',
                path: `${APP_PREFIX_PATH}/customer`,
                title: 'Customer',
                icon: UserOutlined,
                breadcrumb: false,
                show: userAccessData.includes('customer') ? true : false,
                submenu: []
            },
            {
                key: 'complain',
                path: `${APP_PREFIX_PATH}/complain`,
                title: 'Complain',
                icon: IssuesCloseOutlined,
                breadcrumb: false,
                show: userAccessData.includes('complain') ? true : false,
                submenu: []
            },
            {
                key: 'city_management',
                path: `${APP_PREFIX_PATH}/city/list`,
                title: 'City',
                icon: HomeOutlined,
                breadcrumb: false,
                show: userAccessData.includes('city_management') ? true : false,
                submenu: []
            },
            {
                key: 'branch_management',
                path: `${APP_PREFIX_PATH}/branch/list`,
                title: 'Branch',
                icon: ShopOutlined,
                breadcrumb: false,
                show: userAccessData.includes('branch_management') ? true : false,
                submenu: []
            },
            {
                key: 'category_management',
                path: `${APP_PREFIX_PATH}/categories/list`,
                title: 'Category',
                icon: BarsOutlined,
                breadcrumb: false,
                show: userAccessData.includes('category_management') ? true : false,
                submenu: []
            },
            {
                key: 'order_chat',
                path: `${APP_PREFIX_PATH}/chat`,
                title: "Chat",
                icon: MessageOutlined,
                breadcrumb: false,
                show: userAccessData.includes('order_chat') ? true : false,
                submenu: []
            },
            {
                key: 'manage_coupons',
                path: `${APP_PREFIX_PATH}/coupons/list`,
                title: "Coupons",
                icon: GiftOutlined,
                breadcrumb: false,
                show: userAccessData.includes('manage_coupons') ? true : false,
                submenu: []
            },
            {
                key: 'product_management',
                path: `${APP_PREFIX_PATH}/products/`,
                title: 'Products',
                icon: ProfileOutlined,
                breadcrumb: false,
                show:
                    userAccessData.includes('product_management') ||
                        userAccessData.includes('products-list') ||
                        userAccessData.includes('products-type') ||
                        userAccessData.includes('products-size') ||
                        userAccessData.includes('products-choice') ? true : false,
                submenu: [
                    {
                        key: 'products-list',
                        path: `${APP_PREFIX_PATH}/products/list`,
                        title: 'Products',
                        icon: ProfileOutlined,
                        breadcrumb: false,
                        show:
                            userAccessData.includes('product_management') ||
                                userAccessData.includes('products-list') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'product-type',
                        path: `${APP_PREFIX_PATH}/products/list-type`,
                        title: 'Type',
                        icon: ProfileOutlined,
                        breadcrumb: false,
                        show:
                            userAccessData.includes('product_management') ||
                                userAccessData.includes('products-type') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'product-size',
                        path: `${APP_PREFIX_PATH}/products/list-size`,
                        title: 'Size',
                        icon: ProfileOutlined,
                        breadcrumb: false,
                        show:
                            userAccessData.includes('product_management') ||
                                userAccessData.includes('products-size') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'product-choice',
                        path: `${APP_PREFIX_PATH}/products/list-choice`,
                        title: 'Choice',
                        icon: ProfileOutlined,
                        breadcrumb: false,
                        show:
                            userAccessData.includes('product_management') ||
                                userAccessData.includes('products-choice') ? true : false,
                        submenu: []
                    }
                ]
            },
            {
                key: 'order_management',
                path: `${APP_PREFIX_PATH}/orders/`,
                title: 'Orders',
                icon: ShoppingCartOutlined,
                breadcrumb: false,
                show:
                    userAccessData.includes('order_management') ||
                        userAccessData.includes('order-list') ||
                        userAccessData.includes('cancelled-lists') ||
                        userAccessData.includes('delivered-lists') ? true : false,
                submenu: [
                    {
                        key: 'order-list',
                        path: `${APP_PREFIX_PATH}/orders/lists`,
                        title: 'Orders',
                        icon: ShoppingCartOutlined,
                        breadcrumb: false,
                        show:
                            userAccessData.includes('order_management') ||
                                userAccessData.includes('order-list') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'cancelled-lists',
                        path: `${APP_PREFIX_PATH}/orders/cancelled-lists`,
                        title: 'Cancelled Orders',
                        icon: ShoppingCartOutlined,
                        breadcrumb: false,
                        show:
                            userAccessData.includes('order_management') ||
                                userAccessData.includes('cancelled-lists') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'delivered-lists',
                        path: `${APP_PREFIX_PATH}/orders/delivered-lists`,
                        title: 'Delivered Orders',
                        icon: ShoppingCartOutlined,
                        breadcrumb: false,
                        show:
                            userAccessData.includes('order_management') ||
                                userAccessData.includes('delivered-lists') ? true : false,
                        submenu: []
                    }
                ]
            },
            {
                key: 'reports',
                path: `${APP_PREFIX_PATH}/reports/`,
                title: 'Reports',
                icon: LineChartOutlined,
                breadcrumb: false,
                show:
                    userAccessData.includes('reports') ||
                        userAccessData.includes('shop-report') ||
                        userAccessData.includes('delivered-report') ||
                        userAccessData.includes('customer-report') ||
                        userAccessData.includes('coupon-report') ? true : false,
                submenu: [
                    {
                        key: 'shop-report',
                        path: `${APP_PREFIX_PATH}/report/shop`,
                        title: 'Shop',
                        breadcrumb: false,
                        show:
                            userAccessData.includes('reports') ||
                                userAccessData.includes('shop-report') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'delivered-report',
                        path: `${APP_PREFIX_PATH}/report/delivered`,
                        title: 'Delivered',
                        breadcrumb: false,
                        show:
                            userAccessData.includes('reports') ||
                                userAccessData.includes('delivered-report') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'customer-report',
                        path: `${APP_PREFIX_PATH}/report/customer`,
                        title: 'Customer',
                        breadcrumb: false,
                        show:
                            userAccessData.includes('reports') ||
                                userAccessData.includes('customer-report') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'coupon-report',
                        path: `${APP_PREFIX_PATH}/report/coupon`,
                        title: 'Coupons',
                        breadcrumb: false,
                        show:
                            userAccessData.includes('reports') ||
                                userAccessData.includes('coupon-report') ? true : false,
                        submenu: []
                    }
                ]
            },
            {
                key: 'car_management',
                path: `${APP_PREFIX_PATH}/cars/`,
                title: 'Car Management',
                icon: CarOutlined,
                breadcrumb: false,
                show:
                    userAccessData.includes('car_management') ||
                        userAccessData.includes('car-info') ||
                        userAccessData.includes('car-fuel') ||
                        userAccessData.includes('car-preparation') ||
                        userAccessData.includes('car-guarantee-maintenance') ||
                        userAccessData.includes('car-accident') ||
                        userAccessData.includes('car-handover') ||
                        userAccessData.includes('car-takeover') ||
                        userAccessData.includes('car-weekly-report') ||
                        userAccessData.includes('car-maintenance-bill') ||
                        userAccessData.includes('car-maintenance-reminder') ||
                        userAccessData.includes('car-history') ? true : false,
                submenu: [
                    {
                        key: 'car-info',
                        path: `${APP_PREFIX_PATH}/cars/list-car`,
                        title: 'Cars',
                        icon: CarOutlined,
                        breadcrumb: false,
                        show:
                            userAccessData.includes('car_management') ||
                                userAccessData.includes('car-info') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'car-fuel',
                        path: `${APP_PREFIX_PATH}/cars/list-fuel`,
                        title: 'Fuel',
                        icon: CarOutlined,
                        breadcrumb: false,
                        show:
                            userAccessData.includes('car_management') ||
                                userAccessData.includes('car-fuel') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'car-preparation',
                        path: `${APP_PREFIX_PATH}/cars/list-preparation`,
                        title: 'Preparation',
                        icon: CarOutlined,
                        breadcrumb: false,
                        show:
                            userAccessData.includes('car_management') ||
                                userAccessData.includes('car-preparation') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'car-guarantee-maintenance',
                        path: `${APP_PREFIX_PATH}/cars/list-guarantee-maintenance`,
                        title: 'Guarantee Maintenance',
                        icon: CarOutlined,
                        breadcrumb: false,
                        show:
                            userAccessData.includes('car_management') ||
                                userAccessData.includes('car-guarantee-maintenance') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'car-accident',
                        path: `${APP_PREFIX_PATH}/cars/list-accident`,
                        title: 'Accident Incident',
                        icon: CarOutlined,
                        breadcrumb: false,
                        show:
                            userAccessData.includes('car_management') ||
                                userAccessData.includes('car-accident') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'car-handover',
                        path: `${APP_PREFIX_PATH}/cars/list-handover`,
                        title: 'Handover',
                        icon: CarOutlined,
                        breadcrumb: false,
                        show:
                            userAccessData.includes('car_management') ||
                                userAccessData.includes('car-handover') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'car-takeover',
                        path: `${APP_PREFIX_PATH}/cars/list-takeover`,
                        title: 'Takeover',
                        icon: CarOutlined,
                        breadcrumb: false,
                        show:
                            userAccessData.includes('car_management') ||
                                userAccessData.includes('car-takeover') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'car-weekly-report',
                        path: `${APP_PREFIX_PATH}/cars/list-weekly-report`,
                        title: 'Weekly Report',
                        icon: CarOutlined,
                        breadcrumb: false,
                        show:
                            userAccessData.includes('car_management') ||
                                userAccessData.includes('car-weekly-report') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'car-maintenance-bill',
                        path: `${APP_PREFIX_PATH}/cars/list-maintenance-bill`,
                        title: 'Maintenance',
                        icon: CarOutlined,
                        breadcrumb: false,
                        show:
                            userAccessData.includes('car_management') ||
                                userAccessData.includes('car-maintenance-bill') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'car-maintenance-reminder',
                        path: `${APP_PREFIX_PATH}/cars/list-maintenance-reminder`,
                        title: 'Maintenance Reminder',
                        icon: CarOutlined,
                        breadcrumb: false,
                        show:
                            userAccessData.includes('car_management') ||
                                userAccessData.includes('car-maintenance-reminder') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'car-history',
                        path: `${APP_PREFIX_PATH}/cars/history`,
                        title: 'History',
                        icon: CarOutlined,
                        breadcrumb: false,
                        show:
                            userAccessData.includes('car_management') ||
                                userAccessData.includes('car-history') ? true : false,
                        submenu: []
                    },
                ]
            },
            {
                key: 'driver_management',
                path: `${APP_PREFIX_PATH}/drivers/list`,
                title: 'Driver Management',
                icon: UserOutlined,
                breadcrumb: false,
                show:
                    userAccessData.includes('driver_management') ||
                        userAccessData.includes('driver_list') ? true : false,
                submenu: [
                    {
                        key: 'driver_list',
                        path: `${APP_PREFIX_PATH}/drivers/list-driver`,
                        title: 'Driver List',
                        icon: UserOutlined,
                        breadcrumb: false,
                        show:
                            userAccessData.includes('driver_management') ||
                                userAccessData.includes('driver_list') ? true : false,
                        submenu: []
                    }
                ]
            },
            {
                key: 'device_management',
                path: `${APP_PREFIX_PATH}/device/list`,
                title: 'Device Management',
                icon: CompassOutlined,
                breadcrumb: false,
                show:
                    userAccessData.includes('device_management') ||
                        userAccessData.includes('device_map') ||
                        userAccessData.includes('add_device') ? true : false,
                submenu: [
                    {
                        key: 'device_map',
                        path: `${AUTH_PREFIX_PATH}/device/map`,
                        title: 'Map',
                        breadcrumb: false,
                        show:
                            userAccessData.includes('device_management') ||
                                userAccessData.includes('device_map') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'add_device',
                        path: `${APP_PREFIX_PATH}/device/list`,
                        title: 'Device List',
                        breadcrumb: false,
                        show:
                            userAccessData.includes('device_management') ||
                                userAccessData.includes('add_device') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'device_history',
                        path: `${APP_PREFIX_PATH}/device/history`,
                        title: 'Device History',
                        breadcrumb: false,
                        show:
                            userAccessData.includes('device_management') ||
                                userAccessData.includes('device_history') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'device_notification',
                        path: `${APP_PREFIX_PATH}/device/notification`,
                        title: 'Device Notification',
                        breadcrumb: false,
                        show:
                            userAccessData.includes('device_management') ||
                                userAccessData.includes('device_notification') ? true : false,
                        submenu: []
                    }
                ]
            },
            {
                key: 'image_management',
                path: `${APP_PREFIX_PATH}/image_management`,
                title: 'Banners & Advertisement',
                icon: FileImageOutlined,
                breadcrumb: false,
                show:
                    userAccessData.includes('image_management') ||
                        userAccessData.includes('banner_list') ||
                        userAccessData.includes('advertisement_list') ? true : false,
                submenu: [
                    {
                        key: 'banner_list',
                        path: `${APP_PREFIX_PATH}/banners`,
                        title: 'Banners',
                        breadcrumb: false,
                        show:
                            userAccessData.includes('image_management') ||
                                userAccessData.includes('banner_list') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'advertisement_list',
                        path: `${APP_PREFIX_PATH}/advertisement`,
                        title: 'Advertisement',
                        breadcrumb: false,
                        show:
                            userAccessData.includes('image_management') ||
                                userAccessData.includes('advertisement_list') ? true : false,
                        submenu: []
                    }
                ]
            },
            {
                key: 'page_management',
                path: `${APP_PREFIX_PATH}/page`,
                title: 'Page',
                icon: FileImageOutlined,
                breadcrumb: false,
                show:
                    userAccessData.includes('page_management') ||
                        userAccessData.includes('about_page') ||
                        userAccessData.includes('policy_page') ? true : false,
                submenu: [
                    {
                        key: 'about_page',
                        path: `${APP_PREFIX_PATH}/page/about`,
                        title: 'About',
                        breadcrumb: false,
                        show:
                            userAccessData.includes('page_management') ||
                                userAccessData.includes('about_page') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'policy_page',
                        path: `${APP_PREFIX_PATH}/page/policy`,
                        title: 'Policy',
                        breadcrumb: false,
                        show:
                            userAccessData.includes('page_management') ||
                                userAccessData.includes('policy_page') ? true : false,
                        submenu: []
                    }
                ]
            },
            {
                key: 'package_management',
                path: `${APP_PREFIX_PATH}/package/list`,
                title: 'My Account',
                icon: GroupOutlined,
                breadcrumb: false,
                show:
                    userAccessData.includes('package_management') ||
                        userAccessData.includes('package_list') ||
                        userAccessData.includes('order_list') ? true : false,
                submenu: [
                    {
                        key: 'package_list',
                        path: `${APP_PREFIX_PATH}/package/list`,
                        title: 'My Package',
                        icon: GroupOutlined,
                        breadcrumb: false,
                        show:
                            userAccessData.includes('package_management') ||
                                userAccessData.includes('package_list') ? true : false,
                        submenu: []
                    },
                    {
                        key: 'order_list',
                        path: `${APP_PREFIX_PATH}/package/order/list`,
                        title: 'My Orders',
                        icon: GroupOutlined,
                        breadcrumb: false,
                        show:
                            userAccessData.includes('package_management') ||
                                userAccessData.includes('order_list') ? true : false,
                        submenu: []
                    }
                ]
            },
            {
                key: 'setting',
                path: `${APP_PREFIX_PATH}/setting`,
                title: 'Setting',
                icon: SettingOutlined,
                breadcrumb: false,
                show: userAccessData.includes('setting') ? true : false,
                submenu: []
            }

        ]
    }
]

const navigationConfig = [
    ...dashBoardNavTree
]

export default navigationConfig;
